import { useFeatureMenuAdaptableCardsQuery } from 'generated/sanity-graphql';

import { useEnableAdaptableMenuCards } from './use-enable-adaptable-menu-cards';

export const useAdaptableMenuCardsQuery = (featureMenuId: string) => {
  const enableAdaptableMenuCards = useEnableAdaptableMenuCards();

  const response = useFeatureMenuAdaptableCardsQuery({
    variables: { featureMenuId },
    skip: !featureMenuId || !enableAdaptableMenuCards,
  });

  return response;
};
